import { skuTable } from "src/core/articles/sku-lookup";

let _cached: Record<string, string> | undefined;

/** Lazy reverse lookup: SKU → "ProductType|Wood|Metal" key. Dev-only. */
export function getReverseSkuTable(): Record<string, string> {
	if (!_cached) {
		_cached = Object.fromEntries(
			Object.entries(skuTable).map(([key, sku]) => [sku, key]),
		);
	}
	return _cached;
}
